// Convert date to string date (Remove Time & Timezone)
export function toDate(stringDate) {
  if (!stringDate) {
    return "-";
  }
  return new Date(stringDate).toLocaleDateString();
}

// Convert string to Valid date
export function formatDate(date) {
  if (!date) return "-";
  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return "-";
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
